import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=051a6406&scoped=true"
import script from "./Comparison.vue?vue&type=script&lang=js"
export * from "./Comparison.vue?vue&type=script&lang=js"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=051a6406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a6406",
  null
  
)

export default component.exports